import '@babel/polyfill'
/* global Echo, EventBus, $, app */
import { store } from './stores'
import InstantSearch from 'vue-instantsearch'
import Shortkey from 'vue-shortkey'
import vClickOutside from 'v-click-outside'
import Vue from 'vue'
import { mapMutations } from 'vuex'
import { OPEN_SIDEBAR, SET_SCREEN_WIDTH } from './stores/global/mutations'
import PortalVue from 'portal-vue'
import VueKeepScrollPosition from 'vue-keep-scroll-position'

require('./unsupported')
require('./polyfills')
require('./bootstrap')
require('./echo')
require('./components')
require('./filters')

window.EventBus = new Vue()

Vue.use(InstantSearch)
Vue.use(Shortkey, { prevent: ['input', 'textarea'] })
Vue.use(PortalVue)
Vue.use(VueKeepScrollPosition)
Vue.use(vClickOutside)

new Vue({
    el: '#app',
    store,
    created () {
        this.$store.commit('users/setCurrentUser', app.currentUser)
        this.$store.commit('tenant/setTenant', app.currentTenant)
        this.$store.commit(SET_SCREEN_WIDTH, window.innerWidth)

        Echo.join(`${app.currentTenant.id}_online_users`)
            .here((users) => {
                this.$store.commit('users/populateOnlineUsers', (users))
            })
            .joining((user) => {
                this.$store.commit('users/addOnlineUser', (user))
            })
            .leaving((user) => {
                this.$store.commit('users/removeOnlineUser', (user))
            })

        window.addEventListener('resize', () => {
            this.$store.commit(SET_SCREEN_WIDTH, window.innerWidth)
        })
    },

    mounted () {
        $(this.$el).on('click', (event) => {
            EventBus.$emit('AppClick', event)
        })

        if (app.flash) {
            EventBus.$emit('newSnackbar', app.flash)
        }

        // For accessibility, means we can change our focus states.
        document.body.addEventListener('keydown', function(event) {
            if (event.keyCode === 9 ) {
                document.body.classList.add('u-keyboard');
            }
        });

        document.body.addEventListener('mousedown', function() {
            document.body.classList.remove('u-keyboard');
        });

    },

    methods: {
        ...mapMutations({
            'openSidebar': OPEN_SIDEBAR
        })
    }
})
